import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { LuX } from 'react-icons/lu';

const ConfirmationModal = ({ 
  visible, 
  onClose, 
  onConfirm, 
  title = "Are you sure?",
  message = "Do you want to perform this action?",
  cancelText = "No",
  confirmText = "Yes, Submit",
  showIcon = true,
  confirmButtonStyle = "primary", // 'primary' | 'danger' | 'success'
}) => {
  const getConfirmButtonClass = () => {
    switch(confirmButtonStyle) {
      case 'danger':
        return 'bg-red-500 bg-red-600';
      case 'success':
        return 'bg-emerald-500 bg-emerald-600';
      case 'primary':
      default:
        return 'bg-[#18181B] bg-black';
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
      closeIcon={<div className='bg-secondary h-8  w-8 flex justify-center items-center rounded-full'><LuX className="text-red-400" size={20} /></div>}
      className="confirmation-modal"
      centered
    >
      <div className="flex flex-col items-center text-center ">
        {showIcon && (
       <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 160 160" fill="none">
       <path d="M143.734 127.4L90.8676 21.7331C89.8628 19.7102 88.3133 18.0079 86.3934 16.8178C84.4736 15.6278 82.2597 14.9973 80.0009 14.9973C77.7422 14.9973 75.5283 15.6278 73.6085 16.8178C71.6886 18.0079 70.1391 19.7102 69.1343 21.7331L16.2676 127.4C15.3522 129.254 14.9232 131.311 15.021 133.377C15.1187 135.443 15.7401 137.45 16.8266 139.209C17.913 140.969 19.429 142.424 21.2321 143.437C23.0352 144.449 25.0662 144.987 27.1343 145H132.868C134.936 144.987 136.967 144.449 138.77 143.437C140.573 142.424 142.089 140.969 143.175 139.209C144.262 137.45 144.883 135.443 144.981 133.377C145.079 131.311 144.65 129.254 143.734 127.4Z" fill="#FBC02D"/>
       <path d="M87.5351 63.5999C86.6026 62.5149 85.4467 61.6441 84.1465 61.0471C82.8463 60.4502 81.4325 60.1411 80.0018 60.1411C78.5711 60.1411 77.1573 60.4502 75.8571 61.0471C74.5569 61.6441 73.401 62.5149 72.4684 63.5999C71.448 64.8121 70.7143 66.239 70.3218 67.7742C69.9294 69.3094 69.8883 70.9133 70.2018 72.4665L75.0684 99.1332C75.2613 100.302 75.8632 101.365 76.7667 102.132C77.6703 102.899 78.8168 103.319 80.0018 103.319C81.1868 103.319 82.3333 102.899 83.2368 102.132C84.1404 101.365 84.7422 100.302 84.9351 99.1332L89.8018 72.4665C90.1152 70.9133 90.0742 69.3094 89.6817 67.7742C89.2893 66.239 88.5555 64.8121 87.5351 63.5999Z" fill="#424242"/>
       <path d="M80.0002 121.666C83.6821 121.666 86.6668 118.681 86.6668 114.999C86.6668 111.318 83.6821 108.333 80.0002 108.333C76.3183 108.333 73.3335 111.318 73.3335 114.999C73.3335 118.681 76.3183 121.666 80.0002 121.666Z" fill="#424242"/>
       </svg>     
        )}
        
        <h3 className="text-lg font-semibold mb-0">{title}</h3>
        <p className="text-gray-500 text-sm mt-2 mb-4">{message}</p>
        
        <div className="flex gap-3 w-full">
          <Button
            onClick={onClose}
            className="border-0 flex-1 py-2.5 px-4 rounded-xl bg-gray-100 text-gray-600  text-sm font-medium transition-colors"
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            type='primary'
            className={`border-0 flex-1 py-2.5 px-4 rounded-xl text-white text-sm font-medium transition-colors flex items-center justify-center gap-2 ${getConfirmButtonClass()}`}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;